import * as T from '../../types';
import { Dispatch, FC, SetStateAction } from 'react';
import styled from 'styled-components';
import { Tag } from '..';
import { TagTheme } from '../Tag/Tag';

interface Props {
  value: T.Option[];
  setValue: Dispatch<SetStateAction<T.Option[]>>;
  tagTheme?: TagTheme;
}

const MultiValueList: FC<Props> = ({
  value,
  setValue,
  tagTheme = 'primary',
}) => {
  const removeSelectedOption = (option: string) => {
    const filteredValue = value.filter((item) => item.label !== option);
    setValue(filteredValue);
  };

  return (
    <Root>
      {value.map((item, index) => (
        <ListItem key={index}>
          <Tag
            theme={tagTheme}
            value={item.label}
            onClick={removeSelectedOption}
          />
        </ListItem>
      ))}
    </Root>
  );
};

export default MultiValueList;

const Root = styled.ul`
  display: flex;
  flex-wrap: wrap;

  width: 100%;
`;

const ListItem = styled.li`
  margin-top: 8px;

  &:not(:last-child) {
    margin-right: 4px;
  }
`;
